import { IReading } from "../meterReading/meterReading.types"
import { IReadUsageCalculation } from "./readUsageCalculation.types"

export class ReadUsageCalculation implements IReadUsageCalculation {
  constructor(
    public olderReading: IReading,
    public newerReading: IReading,
    public annualLoadProfileRange: number,
  ) {}

  get #usageBetweenReads() {
    return this.newerReading.cumulative - this.olderReading.cumulative
  }

  get #usageBetweenReadsInKwh() {
    return this.#usageBetweenReads * this.olderReading.kwhConversionFactor
  }

  get annualUsage() {
    return Math.round(
      this.#usageBetweenReadsInKwh / this.annualLoadProfileRange,
    )
  }

  get usageBetweenReadsFormatted() {
    const unit =
      this.olderReading.unit === "hcf" ? "ft3" : this.olderReading.unit
    return `${Math.round(this.#usageBetweenReads)} ${unit}`
  }

  get usageBetweenReadsInKwhFormatted() {
    return `${Math.round(this.#usageBetweenReadsInKwh)} kwh`
  }

  get daysBetweenReads() {
    return this.newerReading.date.diff(this.olderReading.date, "day")
  }

  get annualLoadProfileRangeFormatted() {
    return Number(this.annualLoadProfileRange).toFixed(3)
  }
}
